function toggleBios() {
    const bios = document.querySelectorAll('.js_aboutBio');
    Array.from(bios).forEach((element) => {
        element.classList.toggle('about-bio-expanded');
    });
    const elements = document.querySelectorAll('.js_aboutBioToggle');
    Array.from(elements).forEach((element) => {
        if (element.innerHTML === 'See less') {
            element.innerHTML = 'See full bios';
        } else {
            element.innerHTML = 'See less';
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.js_aboutBioToggle');
    Array.from(elements).forEach((element) => {
        element.addEventListener('click', toggleBios);
    });
});
